import { Household, HouseholdStatus } from '../../../common/src/model.ts';
import { localStorageGet, LocalStorageKey, localStorageRemove, localStorageSet } from '../data/client_local_storage.ts';

export const OptimisticSubscriptionTtlMs = 15 * 60 * 1000;

export function storeOptimisticSubscription({
  householdToken,
  sessionId,
  nowMs = Date.now(),
}: {
  householdToken: string;
  sessionId: string;
  nowMs?: number;
}) {
  localStorageSet(LocalStorageKey.OptimisticSubscription, {
    householdToken,
    sessionId,
    createdAtMs: nowMs,
  });
}

export function isOptimisticallySubscribed({
  household,
  nowMs = Date.now(),
}: {
  household?: Pick<Household, 'token' | 'status'>;
  nowMs?: number;
}): boolean {
  return !!getFreshOptimisticSubscription({ householdToken: household?.token, nowMs });
}

export function reconcileOptimisticSubscription({
  household,
  nowMs = Date.now(),
}: {
  household?: Pick<Household, 'token' | 'status'>;
  nowMs?: number;
}) {
  if (household?.status === HouseholdStatus.Subscribed) {
    clearOptimisticSubscription();
    return;
  }
  getFreshOptimisticSubscription({ householdToken: household?.token, nowMs });
}

export function clearOptimisticSubscription() {
  localStorageRemove(LocalStorageKey.OptimisticSubscription);
}

function getFreshOptimisticSubscription({ householdToken, nowMs }: { householdToken?: string; nowMs: number }) {
  const optimisticSubscription = localStorageGet(LocalStorageKey.OptimisticSubscription);
  if (!optimisticSubscription) {
    return;
  }
  if (!householdToken || optimisticSubscription.householdToken !== householdToken) {
    return;
  }
  if (nowMs - optimisticSubscription.createdAtMs >= OptimisticSubscriptionTtlMs) {
    clearOptimisticSubscription();
    return;
  }
  return optimisticSubscription;
}
